import { render, staticRenderFns } from "./HqBudgetTab.vue?vue&type=template&id=50c18a61"
import script from "./HqBudgetTab.vue?vue&type=script&lang=js"
export * from "./HqBudgetTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports